query GET_MYSITE {
  mysite {
    domain
    id
    name
    config
  }
}
